import React, { useCallback, useEffect, useState, useRef } from "react";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../Context/LanguageContext";
import { toast } from "react-toastify";
import { PageHeader } from "../MuiOverRideComponent/PageHeader";
import { BiExport } from "react-icons/bi";
import { FaFileCsv } from "react-icons/fa";
import UserManagementActions from "../../Actions/UserManagementActions";
import UsermanagementConstants from "../../Constants/UsermanagementConstants";
import usermanagementStore from "../../Stores/UsermanagementStore";
import { MdDownloadForOffline, MdError, MdRefresh } from "react-icons/md";
import { CircularProgress, Typography } from "@mui/material";
var dateFormat = require("dateformat");

const POLLING_INTERVAL = 5000;

export default function ExportOrganisationData(props) {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [orgDetails, setOrgDetails] = useState(null);
  const [arbeitsmittelExportStatus, setArbeitsmittelExportStatus] =
    useState(null);

  const arbeitsmittelPollingRef = useRef(null);

  const getOrganisation = () => {
    setGlobalSpinner(true);
    UserManagementActions.getOrganisation(
      sessionStorage.getItem("organizationID"),
    );
  };

  const getArbeitsmittelExportStatus = () => {
    UserManagementActions.getArbeitsmittelExportStatus();
  };

  const startArbeitsmittelPolling = useCallback(() => {
    if (arbeitsmittelPollingRef.current) {
      clearInterval(arbeitsmittelPollingRef.current);
    }
    arbeitsmittelPollingRef.current = setInterval(() => {
      getArbeitsmittelExportStatus();
    }, POLLING_INTERVAL);
  }, []);

  const stopArbeitsmittelPolling = useCallback(() => {
    if (arbeitsmittelPollingRef.current) {
      clearInterval(arbeitsmittelPollingRef.current);
      arbeitsmittelPollingRef.current = null;
    }
  }, []);

  useEffect(() => {
    return () => {
      stopArbeitsmittelPolling();
    };
  }, [stopArbeitsmittelPolling]);

  useEffect(() => {
    getOrganisation();
    getArbeitsmittelExportStatus();
  }, []);

  useEffect(() => {
    if (arbeitsmittelExportStatus?.status === "Exporting") {
      startArbeitsmittelPolling();
    } else {
      stopArbeitsmittelPolling();
    }
  }, [
    arbeitsmittelExportStatus?.status,
    startArbeitsmittelPolling,
    stopArbeitsmittelPolling,
  ]);

  useEffect(() => {
    function organisationExportDetailsSuccess() {
      var res = usermanagementStore.getOrganisationExportDetails();
      if (res) {
        setOrgDetails(res);
      }
      setGlobalSpinner(false);
    }

    function organisationExportDetailsFailure() {
      var res = usermanagementStore.getOrganisationExportDetails();
      toast.error(res);
      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_ORGANISATION_EXPORT_DETAILS_SUCCESS,
      organisationExportDetailsSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_ORGANISATION_EXPORT_DETAILS_FAILURE,
      organisationExportDetailsFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_ORGANISATION_EXPORT_DETAILS_SUCCESS,
        organisationExportDetailsSuccess,
      );
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_ORGANISATION_EXPORT_DETAILS_FAILURE,
        organisationExportDetailsFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getStatusSuccess() {
      var res = usermanagementStore.getArbeitsmittelExportStatus();
      if (res) {
        setArbeitsmittelExportStatus(res);
      }
    }

    function getStatusFailure() {
      var res = usermanagementStore.getArbeitsmittelExportStatus();
      toast.error(res);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_ARBEITSMITTEL_EXPORT_STATUS_SUCCESS,
      getStatusSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_ARBEITSMITTEL_EXPORT_STATUS_FAILURE,
      getStatusFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_ARBEITSMITTEL_EXPORT_STATUS_SUCCESS,
        getStatusSuccess,
      );
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_ARBEITSMITTEL_EXPORT_STATUS_FAILURE,
        getStatusFailure,
      );
    };
  }, []);

  useEffect(() => {
    function exportOrganisationDataSuccess() {
      var res = usermanagementStore.getExportOrganisationDataResult();
    }

    function exportOrganisationDataFailure() {
      var res = usermanagementStore.getExportOrganisationDataResult();
      toast.error(res);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.EXPORT_ORGANISATION_DATA_SUCCESS,
      exportOrganisationDataSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.EXPORT_ORGANISATION_DATA_FAILURE,
      exportOrganisationDataFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.EXPORT_ORGANISATION_DATA_SUCCESS,
        exportOrganisationDataSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.EXPORT_ORGANISATION_DATA_FAILURE,
        exportOrganisationDataFailure,
      );
    };
  }, []);

  useEffect(() => {
    function downloadOrganisationDataSuccess() {
      var res = usermanagementStore.getDownloadOrganisationDataResult();
      handleOrgDataExportDownload(res);
      toast.success(localization.orgDataExportSuccess);
      setGlobalSpinner(false);
    }

    function downloadOrganisationDataFailure() {
      var res = usermanagementStore.getDownloadOrganisationDataResult();
      setGlobalSpinner(false);
      toast.error(res);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.DOWNLOAD_ORGANISATION_DATA_SUCCESS,
      downloadOrganisationDataSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.DOWNLOAD_ORGANISATION_DATA_FAILURE,
      downloadOrganisationDataFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.DOWNLOAD_ORGANISATION_DATA_SUCCESS,
        downloadOrganisationDataSuccess,
      );
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.DOWNLOAD_ORGANISATION_DATA_FAILURE,
        downloadOrganisationDataFailure,
      );
    };
  }, []);

  useEffect(() => {
    function exportArbeitsmittelSuccess() {
      var res = usermanagementStore.getExportArbeitsmittelgruppenResult();
      setGlobalSpinner(false);

      if (res && res.success) {
        toast.info(res.message || localization.exportIsBeingPrepared);
        getArbeitsmittelExportStatus();
      } else if (res) {
        toast.warning(localization.exportRequestSent);
        getArbeitsmittelExportStatus();
      } else {
        toast.error(localization.unexpectedResponse);
      }
    }

    function exportArbeitsmittelFailure() {
      var res = usermanagementStore.getExportArbeitsmittelgruppenResult();
      setGlobalSpinner(false);
      toast.error(res || "Export fehlgeschlagen.");
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.EXPORT_ARBEITSMITTELGRUPPEN_SUCCESS,
      exportArbeitsmittelSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.EXPORT_ARBEITSMITTELGRUPPEN_FAILURE,
      exportArbeitsmittelFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.EXPORT_ARBEITSMITTELGRUPPEN_SUCCESS,
        exportArbeitsmittelSuccess,
      );
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.EXPORT_ARBEITSMITTELGRUPPEN_FAILURE,
        exportArbeitsmittelFailure,
      );
    };
  }, []);

  useEffect(() => {
    function downloadArbeitsmittelSuccess() {
      var res = usermanagementStore.getDownloadArbeitsmittelExportResult();
      handleArbeitsmittelExportDownload(res);
      toast.success(localization.exportSuccess || "Export erfolgreich");
      setGlobalSpinner(false);
    }

    function downloadArbeitsmittelFailure() {
      var res = usermanagementStore.getDownloadArbeitsmittelExportResult();
      setGlobalSpinner(false);
      toast.error(res);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.DOWNLOAD_ARBEITSMITTEL_EXPORT_SUCCESS,
      downloadArbeitsmittelSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.DOWNLOAD_ARBEITSMITTEL_EXPORT_FAILURE,
      downloadArbeitsmittelFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.DOWNLOAD_ARBEITSMITTEL_EXPORT_SUCCESS,
        downloadArbeitsmittelSuccess,
      );
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.DOWNLOAD_ARBEITSMITTEL_EXPORT_FAILURE,
        downloadArbeitsmittelFailure,
      );
    };
  }, []);

  const handleOrgDataExportDownload = useCallback((exportData) => {
    if (exportData !== null && exportData !== undefined) {
      const url = window.URL.createObjectURL(exportData);
      let a = document.createElement("a");
      let name =
        "Organisation_" +
        sessionStorage.getItem("organization") +
        "_" +
        dateFormat(Date(), "yyyy-mm-dd_hh-mm-ss") +
        ".zip";
      a.hidden = "";
      a.href = url;
      a.download = name;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }, []);

  const handleArbeitsmittelExportDownload = useCallback((exportData) => {
    if (exportData !== null && exportData !== undefined) {
      const url = window.URL.createObjectURL(exportData);
      let a = document.createElement("a");
      let name =
        "Arbeitsmittelexport_" +
        sessionStorage.getItem("organization") +
        "_" +
        dateFormat(Date(), "yyyy-mm-dd_hh-mm-ss") +
        ".csv";
      a.hidden = "";
      a.href = url;
      a.download = name;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }, []);

  return (
    <>
      <div className="w-100" id="content">
        <div className="pt-4 d-flex justify-content-between">
          <PageHeader Title={localization.genSetting + " / " + "Export"} />
        </div>
        <div>
          <Typography variant="h5" className="mt-4 mb-3">
            {localization.exportOrgDataInfoMessage}
          </Typography>
          <Typography variant="h5" className="mb-3">
            <b>{localization.exportOrgDataNoteMessage}</b>
          </Typography>
        </div>
        <div>
          {orgDetails && (
            <table className="table table-striped table-bordered mt-4">
              <thead>
                <tr>
                  <th>{localization.organisation}</th>
                  <th style={{ width: "200px" }}>
                    {localization.lastExportDate}
                  </th>
                  <th style={{ width: "320px" }}>{localization.action}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{orgDetails.name}</td>
                  <td>{orgDetails.exportDate}</td>
                  <td className="d-flex align-items-center">
                    {orgDetails.exportStatus !== "Exporting" && (
                      <BiExport
                        id="ExportOrgDataTest"
                        className="cursorPoint svgIcon ml-3"
                        title={localization.exportOrgData}
                        size={27}
                        onClick={() => {
                          UserManagementActions.exportOrganisationData(
                            orgDetails.id,
                          );
                          toast.success(
                            localization.organisationDataPreparedForDownload,
                          );
                          setTimeout(() => {
                            getOrganisation();
                          }, 5000);
                        }}
                      />
                    )}

                    {orgDetails.exportStatus === "Exported" && (
                      <MdDownloadForOffline
                        id="DownloadOrgDataTest"
                        className="cursorPoint svgIcon ml-3"
                        title={localization.downloadOrgData}
                        size={27}
                        onClick={() => {
                          setGlobalSpinner(true);
                          UserManagementActions.downloadOrganisationData(
                            orgDetails.id,
                          );
                        }}
                      />
                    )}

                    {orgDetails.exportStatus === "Exporting" && (
                      <>
                        <CircularProgress
                          size={22}
                          title={localization.exportingData}
                          className="ml-3"
                        />
                        <MdRefresh
                          id="refreshOrganisationList"
                          className="cursorPoint svgIcon ml-3"
                          title={localization.refresh || "Refresh"}
                          size={25}
                          onClick={() => {
                            getOrganisation();
                          }}
                        />
                      </>
                    )}
                    {orgDetails.exportStatus === "Failed" && (
                      <MdError
                        title={localization.exportFailed}
                        size={27}
                        color="red"
                      />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          )}

          <Typography variant="h5" className="mt-5 mb-3">
            {localization.exportAllWorkEquipment}
          </Typography>
          {orgDetails && (
            <table className="table table-striped table-bordered mt-4">
              <thead>
                <tr>
                  <th>{localization.exportType}</th>
                  <th style={{ width: "200px" }}>
                    {localization.lastExportDate}
                  </th>
                  <th style={{ width: "320px" }}>{localization.action}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {localization.exportAllEquipment}
                    {arbeitsmittelExportStatus &&
                      arbeitsmittelExportStatus.arbeitsmittelCount > 0 && (
                        <span className="text-muted ml-2">
                          (
                          {arbeitsmittelExportStatus.arbeitsmittelCount.toLocaleString()}{" "}
                          {localization.equipments})
                        </span>
                      )}
                  </td>
                  <td>{arbeitsmittelExportStatus?.exportDate || "-"}</td>
                  <td className="d-flex align-items-center">
                    {arbeitsmittelExportStatus?.status !== "Exporting" && (
                      <FaFileCsv
                        id="ExportArbeitsmittelTest"
                        className="cursorPoint svgIcon ml-3"
                        title={localization.exportCSV}
                        size={27}
                        color="#28a745"
                        onClick={() => {
                          setGlobalSpinner(true);
                          UserManagementActions.startArbeitsmittelExport();
                        }}
                      />
                    )}

                    {arbeitsmittelExportStatus?.status === "Exported" && (
                      <MdDownloadForOffline
                        id="DownloadArbeitsmittelTest"
                        className="cursorPoint svgIcon ml-3"
                        title={localization.download}
                        size={27}
                        onClick={() => {
                          setGlobalSpinner(true);
                          UserManagementActions.downloadArbeitsmittelExport();
                        }}
                      />
                    )}

                    {arbeitsmittelExportStatus?.status === "Exporting" && (
                      <>
                        <CircularProgress
                          size={22}
                          title={
                            localization.exportingData || "Export läuft..."
                          }
                          className="ml-3"
                        />
                        <MdRefresh
                          id="refreshArbeitsmittelExportStatus"
                          className="cursorPoint svgIcon ml-3"
                          title={localization.refresh || "Aktualisieren"}
                          size={25}
                          onClick={() => {
                            getArbeitsmittelExportStatus();
                          }}
                        />
                      </>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
